import React from "react";
import { connect } from "react-redux";
import TeacherPageContainer from "../Container/TeacherPageContainer";
import TeacherJobListContents from "./TeacherJobListContents";
import "./JobList.css";
import TeacherJobListNewContent from "./TeacherJobListNewContent";

function TeacherJobList(props) {
    const tabs = [
        {
            text: "My Calendar",
            pathname: "/MyCalendar"
        },
        {
            text: "Job List",
            pathname: "/TeacherJobList",
            active: true
        }
    ]

    return (
        <TeacherPageContainer
            header="Job List"
            tabs={tabs}
        >
            <TeacherJobListNewContent
                user={props.user}
            />
        </TeacherPageContainer>
    );
}

const mapStateToProps = function (state) {
    return {
        user: state.user.user,
    };
};

export default connect(mapStateToProps)(TeacherJobList);
